import { AType, summon } from "@silversea-ssc/functional-support"
import { Int } from "io-ts"

const PositiveInt = summon((F) =>
    F.number({
        IoTsURI: (_x, { withValidate }) => withValidate(_x, Int.validate),
        FastCheckURI: (_x, { fastCheck }) => fastCheck.integer({ min: 0 }),
    }),
)

export const _Occupancy = summon((F) =>
    F.interface(
        {
            adults: PositiveInt(F),
            kids: PositiveInt(F),
        },
        "Occupancy",
    ),
)

export type Occupancy = AType<typeof _Occupancy>

const totalGuests = (occupancy: Occupancy): number => occupancy.adults + occupancy.kids

export const Occupancy = /* @__PURE__ */ Object.assign(_Occupancy, {
    totalGuests,
    otherGuests: (occupancy: Occupancy): number => totalGuests(occupancy) - 1,
    of: (adults: number, kids = 0): Occupancy => Occupancy.build({ adults, kids }),
})
